import { useEffect, useRef, useState } from 'react'

function pad2(n: number): string {
  return n.toString().padStart(2, '0')
}

/**
 * Format elapsed seconds as mm:ss, or hh:mm:ss if >= 1 hour.
 */
export function formatCallDuration(totalSeconds: number): string {
  const h = Math.floor(totalSeconds / 3600)
  const m = Math.floor((totalSeconds % 3600) / 60)
  const s = totalSeconds % 60
  if (h > 0) {
    return `${pad2(h)}:${pad2(m)}:${pad2(s)}`
  }
  return `${pad2(m)}:${pad2(s)}`
}

/**
 * Returns the current call duration as mm:ss (or hh:mm:ss if >= 1 hour),
 * updating every second. Starts counting when isActive becomes true.
 */
export function useCallDuration(isActive: boolean): string {
  const startTimeRef = useRef<number | null>(null)
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    if (isActive && startTimeRef.current === null) {
      startTimeRef.current = Date.now()
      setElapsed(0)
    }
    if (!isActive) {
      startTimeRef.current = null
      setElapsed(0)
      return
    }
    const interval = setInterval(() => {
      if (startTimeRef.current === null) return
      setElapsed(Math.floor((Date.now() - startTimeRef.current) / 1000))
    }, 1000)
    return () => clearInterval(interval)
  }, [isActive])

  return formatCallDuration(elapsed)
}
